<template>
  <div id="datatable-history-entity-packs">
        <v-data-table
            :headers="headers"
            :items="listHistoryPacks"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [5, 10]
            }"
        >

        <template v-slot:[`item.creationDateTime`]="{ item }">
            <span>{{ item.creationDateTime | formatOnlyDate}}</span>
        </template>
        <template v-slot:[`item.userSourceName`]="{ item }">
            <span v-if="item.userSourceName && item.entitySourceName">{{ `${item.userSourceName} | ${item.entitySourceName}` }}</span>
        </template>

        </v-data-table>
    </div>
</template>

<script>
export default {
     props: {
        listHistoryPacks: Array | Object,
        searchCount: Number,
        totalItems: Number | String
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t('backoffice.modules-management.vrm.config-access.datatable-history.headers.create-date'),
                    align: "start",
                    value: "creationDateTime",
                    width: "15%",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.vrm.config-access.datatable-history.headers.qty'),
                    align: "start",
                    value: "chargedBalance",
                    width: '10%',
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.vrm.config-access.datatable-history.headers.entity-destiny'),
                    align: "start",
                    value: "entityDestinyName",
                    width: "15%",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.vrm.config-access.datatable-history.headers.user-destiny'),
                    align: "center",
                    value: "userDestinyName",
                    width: "15%",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.modules-management.vrm.config-access.datatable-history.headers.source-account'),
                    align: "center",
                    value: "userSourceName",
                    width: "20%",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10
            },
        };
    },
     watch: {
      "options.page": {
        handler() {
          this.$emit('alterTableHistoryEntity', this.options);
        },
      },
      "options.itemsPerPage": {
        handler() {
          this.$emit('alterTableHistoryEntity', this.options);
        },
      },
      searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTableHistoryEntity", this.options);
            },
        },
    },
}
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-history-entity-packs {
    table {
        thead {
            tr {
                th {
                    border: 0;
                    
                    &.header-table-color {
                        background-color: #f2f2f2 !important;
                        color: #9e9d9d !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 12px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }

    .span-packs {
        color: var(--v-primary-base);
        cursor: pointer;
    }
}
</style>
